import React, { useContext } from "react";
import { ResourceContext } from "../../Service/Context/ResourceContext";
import ProfileContactInfo from "./ProfileContactInfo";

const ProfileContactInfoTopRight = ({ language, documentType, documentLayoutPlacement }) => {
  const { documentLayout } = useContext(ResourceContext);
  const placement = documentLayoutPlacement ?? documentLayout?.infoBoxPlacement;

  if (placement !== "RIGHT") {
    return null;
  }
  return (
    <ProfileContactInfo language={language} documentType={documentType} />
  );
};

export default ProfileContactInfoTopRight;
